import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import weekPlannerMessages from '@/modules/tasks/weekplanner/weekPlannerMessages';
import { TaskQueryKey } from './queryKey';
export const useGetWeekPlannerExternalEvents = (params, enabled) => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.WeekPlannerExternalEvents, params.from, params.to], () => api.base
        .get(`${config.appUrls.connectCalendarApi}/api/calendar/availability`, {
        params,
    })
        .then(res => res.data), {
        enabled: enabled && !!params.from && !!params.to,
        // 409 is the deterministic "reconnect your calendar" signal — retrying only delays the toast.
        retry: (failureCount, queryError) => { var _a; return ((_a = queryError === null || queryError === void 0 ? void 0 : queryError.response) === null || _a === void 0 ? void 0 : _a.status) !== 409 && failureCount < 3; },
        onError: () => {
            ToastrService.error(intl.formatMessage(weekPlannerMessages.CalendarConnectionError));
        },
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
